import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useAgentAuthStore } from '~/stores/agentAuth'

export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.startsWith('/agent') || to.path === '/agent/login') return

  const auth = useAgentAuthStore()

  // ✅ 已登录且 session 检查过，直接放行
  if (auth.agent && auth.sessionChecked) return

  // ✅ 正在刷新页面但 session 尚未检查，先等待页面层去验证，不跳转
  if (!auth.sessionChecked) return

  // ❌ 没有登录信息，跳转登录页
  return navigateTo('/agent/login')
})
